var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.953,
    height: 12.562,
    viewBox: "0 0 16.953 12.562",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16424",
    d: "M17.945 5.774A2.082 2.082 0 0 0 15.892 4H3.109a2.082 2.082 0 0 0-2.053 1.774L9.5 11.238z",
    transform: "translate(-1.024 -4)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16425",
    d: "M9.783 14.771a.565.565 0 0 1-.614 0L1 9.486v7.377a2.087 2.087 0 0 0 2.085 2.085h12.783a2.087 2.087 0 0 0 2.085-2.085V9.485z",
    transform: "translate(-1 -6.385)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.32ee59101d485f2ceea64b0742d2fa52.svg";
export { ForwardRef as ReactComponent };